export const SEARCHES_MAX_NUM = 19;
export const SEARCH_NAME_MAX_LENGTH = 48;

export const LLM_REQ_REJECTED = 7;
